import _extends from "@babel/runtime/helpers/extends";
import { Box, Heading, Text } from '@wix/design-system';
import React from 'react';
import { useDeclaredExperiments } from '../../hooks/declaredExperiments';
import { useOpenTldResults } from '../../hooks/useOpenTldResults';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { getFallback } from '../TldPromotionsWithPrice/TldPromotionsWithPrice';
import { tldPromotionsApiClient } from '../TldPromotionsWithPrice/TldPromotionsWithPrice.apiClient';
import { TldPromotionBox, TldPromotionBoxSkeleton } from './TldPromotionBox';
import s from './tldPromotionBoxes.scss';
const PROMOTIONS_LIMIT = 8;
export const TldPromotionBoxes = () => {
  var _data$tldPromotionsWi;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const openTldResults = useOpenTldResults();
  const experimentIds = useDeclaredExperiments();
  const {
    data,
    isLoading,
    error
  } = tldPromotionsApiClient.hooks.useTldPromotionsWithPrice({
    limit: PROMOTIONS_LIMIT,
    experimentIds
  }, true, {
    useErrorBoundary: false
  });
  const promotions = error || !(data != null && (_data$tldPromotionsWi = data.tldPromotionsWithPrice) != null && _data$tldPromotionsWi.length) ? getFallback(t) : data.tldPromotionsWithPrice;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    align: "center",
    gap: "16px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    align: "center",
    gap: "15px",
    paddingTop: "40px"
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "24px 0 18px 0"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t('domain_search_gate.domain_gate.tld_section.header'))), /*#__PURE__*/React.createElement("div", {
    className: s.grid
  }, isLoading ? Array.from({
    length: PROMOTIONS_LIMIT
  }, (_, index) => /*#__PURE__*/React.createElement(TldPromotionBoxSkeleton, {
    key: index
  })) : promotions.map((_ref, index) => {
    let {
      tld,
      ...promotion
    } = _ref;
    return /*#__PURE__*/React.createElement(TldPromotionBox, _extends({
      key: promotion.id
    }, promotion, {
      tld: tld,
      onClick: tld ? () => {
        var _promotion$pricing, _promotion$pricing2;
        return openTldResults(tld, {
          position: index + 1,
          numOfTlds: promotions.length,
          tldPrice: ((_promotion$pricing = promotion.pricing) == null ? void 0 : _promotion$pricing.price) ?? undefined,
          isSale: Boolean((_promotion$pricing2 = promotion.pricing) == null ? void 0 : _promotion$pricing2.originalPrice)
        });
      } : undefined
    }));
  }))), /*#__PURE__*/React.createElement(Box, {
    className: s.disclaimer
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin",
    secondary: true,
    light: true
  }, t('domain_search_gate.domain_gate.pricing_disclaimer'))));
};
//# sourceMappingURL=TldPromotionBoxes.js.map